import {UMakeTypes} from "../../cars_data/cars_data";
import {UMakeKeys} from "../list/url_utils/tag_utils";
import {toMakePathSlug} from "./make_slug_to_api_type";

/** All UMakeTypes keys are URL-safe single path segments. */
const routableMakeSlugs = new Set(Object.keys(UMakeTypes));

/**
 * Maps API make labels (e.g. "Alfa Romeo") or slugs (e.g. "mercedesbenz") to route keys.
 */
export const getMakeSlug = (make: string): UMakeKeys | undefined => {
    const normalized = make.trim();
    if (!normalized) {
        return undefined;
    }

    const lower = normalized.toLocaleLowerCase("pl");
    const compact = toMakePathSlug(normalized);

    const slug = (
        Object.prototype.hasOwnProperty.call(UMakeTypes, compact)
            ? compact
            : Object.prototype.hasOwnProperty.call(UMakeTypes, lower)
              ? lower
              : Object.entries(UMakeTypes).find(([, label]) => label.toLocaleLowerCase("pl") === lower)?.[0]
    ) as UMakeKeys | undefined;

    if (!slug || !routableMakeSlugs.has(slug)) {
        return undefined;
    }

    return slug;
};
